import { map } from 'lodash/fp';

import { ApiExceptionInline, ApiExceptionModal, apiException } from './ApiException';

import { ALL_REGISTERED_EXCEPTIONS } from './RegisteredExceptions';

const ErrorProvider = ({ children }) => (
    <>
        {children}
        {map(
            v => (
                <ApiExceptionModal key={v} stateKey={v} />
            ),
            ALL_REGISTERED_EXCEPTIONS
        )}
    </>
);

export default ErrorProvider;

export { ALL_REGISTERED_EXCEPTIONS, ApiExceptionInline, ApiExceptionModal, apiException };
